<script lang="ts">
  import { copy } from "../lib/stores/copy";
  import InvalidFieldMessage from "./Input/InvalidFieldMessage.svelte";
  import { notify } from "../lib/helpers/bugsnag";
  import { isDemo } from "../lib/stores/mode";
  import SampleReceipt from "../assets/sample-receipt.webp";
  import { nextStep, route, setLoading } from "../lib/stores/route";
  import { countryStore } from "../lib/stores/country";
  import { saveCode } from "../lib/helpers/code";
  import CloseButton from "./CloseButton.svelte";
  import { isPrimaryCampaign } from "../lib/constants/countries";

  export let toggleType: () => void;

  let code: string;
  let invalidMessage = "";
  let validateOnChange = false;
  let showReceiptPopup = false;

  const validateCode = () => {
    invalidMessage = code?.length === 7 ? "" : $copy.code.invalidCode;
  };

  const submitCode = async () => {
    validateCode();

    validateOnChange = true;

    if (!invalidMessage) {
      try {
        setLoading(true);

        if (!isDemo()) {
          await saveCode(code);
        }

        nextStep();
      } catch (error) {
        notify({ errorMessage: "Failed to save code", error });
        console.error(error);
        invalidMessage = $copy.code.failedToSaveCode;
        setLoading(false);
      }
    }
  };
</script>

{#if showReceiptPopup}
  <div class="fixed inset-0 flex items-center justify-center z-[100] transition duration-200 bg-black bg-opacity-50">
    <div class="relative border-solid border-white border-4 rounded-[6px] bg-cover bg-no-repeat bg-center overflow-y-scroll">
      <CloseButton onClick={() => showReceiptPopup = false} classNames="bg-dark" />
      <img src={SampleReceipt} alt="" class="max-h-[80vh]">
    </div>
  </div>
{/if}

<main class="bg-cover bg-no-repeat bg-[center_top] bg-[url('/bg/mobile-bg4.webp')] h-full tabletLg:bg-[url('/bg/primary-bg.webp')] px-[8px] tabletLg:pb-[42px] laptop:pt-[132px] pb-[120vw] w-full text-center px-[16px]" class:hidden={$route.isLoading}>
  <div class="flex flex-col items-center justify-center h-full mb-[calc(118px+1rem)] laptop:mb-4">
    <div class="p-4 bg-black/50 rounded-md my-4 w-full tablet:w-auto">
      <h1 class="font-MrEavesXLSanNarOTUltra flex flex-col items-center text-primary leading-[0.75] uppercase mb-[14px] text-[38px] tablet:block laptop:mb-[20px] mobileS:text-[50px] mobile:text-[60px] tablet:text-[72px] tabletLg:text-[85px] laptop:text-[100px] desktop:text-[110px] desktopLg:text-[140px]">
        {@html $copy.code.title}
      </h1>
      <div class="font-MrEavesXLSanNarOTUltra text-white font-black leading-[0.9] max-w-[490px] mx-auto uppercase text-[16px] mb-[24px] mobileS:text-[20px] tablet:max-w-[720px] tablet:mb-[58px] tablet:text-[24px] laptop:text-[26px] desktop:text-[30px] desktopLg:text-[37px] desktopLg:max-w-[950px]">
        {@html $copy.code.subtitle}
      </div>
      <form class="flex flex-col items-center">
        <div class="relative flex items-center justify-center w-full max-w-[360px] tablet:max-w-[550px] desktopLg:max-w-[650px]">
          <div class="grow mr-[-4px]">
            <input
              class="relative font-MrEavesXLSanNarOTUltra text-[16px] px-[12px] w-full h-[42px] bg-white text-dark border-solid border-transparent border-2 text-normal outline-none placeholder:text-dark tablet:text-[18px] desktop:text-[22px] tablet:h-[48px] laptop:h-[56px]"
              autocapitalize="off"
              type="text"
              placeholder="{$copy.code.label}"
              bind:value={code}
              on:input={() => validateOnChange && validateCode()}
            >
          </div>
          <button
            class="std-button font-MrEavesXLSanNarOTUltra relative inline-flex justify-center items-center text-[16px] whitespace-nowrap text-white px-[12px] uppercase h-[42px] min-w-[104px] bg-dark border-solid border-white border-2 no-underline uppercase transition cursor-pointer overflow-hidden mobileS:min-w-[132px] tablet:text-[18px] tablet:min-w-[204px] tablet:h-[48px] laptop:h-[56px]"
            on:click|preventDefault={submitCode}
          >
            <span class="relative z-[1]">
              {$copy.code.button}
            </span>
          </button>
          <InvalidFieldMessage message={invalidMessage} />
        </div>
        <div class="font-MrEavesXLSanNarOT text-[10px] text-white text-center mt-[10px] mb-8 leading-[1.1] mobileS:text-[13px] tablet:text-[16px] laptop:text-[18px] desktop:text-[20px]">
          {#if isPrimaryCampaign}
            {$copy.code.findCode}
            <div class="inline">
              <a href="/" on:click|preventDefault={() => showReceiptPopup = !showReceiptPopup} class="underline">
                {$copy.code.findCodeLink}.
              </a>
            </div>
            <br>
          {/if}
          {$copy.code.limits}
        </div>
        {#if $countryStore !== 'US'}
          <div class="font-MrEavesXLSanNarOT text-[10px] text-white text-center leading-[1.1] mobileS:text-[13px] tablet:text-[16px] laptop:text-[18px] desktop:text-[20px]">
            {$copy.code.noCodeTryReceipt.initial} <a href="/" on:click|preventDefault={toggleType} class="underline">{$copy.code.noCodeTryReceipt.linked}</a>.
          </div>
        {/if}
      </form>
    </div>
  </div>
</main>
